// https://dev.to/diegocasmo/scroll-to-input-on-formik-failed-submission-1c3c

import {useFormikContext} from "formik";
import {useEffect} from "react";
import {getFieldErrorNames} from "./getFieldErrorNames";

export const ScrollToFieldError = () => {
    const {submitCount, isValid, errors} = useFormikContext();

    useEffect(() => {
        if (isValid) {
            return;
        }

        const fieldErrorNames = getFieldErrorNames(errors);
        if (fieldErrorNames.length <= 0) {
            return;
        }

        const element = document.querySelector(
            `input[name='${fieldErrorNames[0]}']`
        )
        if (!element) {
            return;
        }

        // Scroll to first known error into view
        element.scrollIntoView({behavior: "smooth", block: "end", inline: "nearest"});
    }, [submitCount]); // eslint-disable-line react-hooks/exhaustive-deps

    return null;
}
